export const Bio = {
  name: "Rakesh Kumar",
  roles: [
    "Associate Product Manager",
    "Product Strategist",
    "User Research Enthusiast",
    "Agile Practitioner",
  ],
  description:
    "Results-driven Product Manager with 1+ year of experience driving product strategy and execution in B2C/B2B Ecommerce and real estate technology. Proven track record of delivering data-driven product features, conducting user research, and collaborating with cross-functional teams to optimize product-market fit. Strong analytical skills with expertise in PRD documentation, stakeholder management, and agile methodologies.",
  github: "https://github.com/Rakeshere",
  resume:
    "https://drive.google.com/file/d/1zN8CsL2GUsDzBhF0Vz-SZAgxipWwCZzG/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/merakesh/",
  twitter: "https://x.com/iamrakeshkr_",
  insta: "https://www.instagram.com/iamrakesh__/",
  facebook: "https://www.facebook.com/iamrakesh788/",
  email: "kumarrakesh51530@gmail.com",
  phone: "+91-7889440384",
};

export const FounderDetails = {
  img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLChBIOUdoAJdB9qEo5XXWAAw7IcKaFwOFbXOMic0k9A&s",
  company: "Muftlo",
  role: "Associate Product Manager",
  description:
    "Led end-to-end product development for a B2B Real Estate Property Discovery Platform, delivering 25+ features across web and mobile. Drove user satisfaction up by 35% through 20+ user interviews and data-driven insights.",
};

export const workflowStats = [
  { label: "Features Shipped", value: "25+" },
  { label: "User Satisfaction ▲", value: "35%" },
  { label: "User Acquisition ▲", value: "40%" },
  { label: "PRDs Written", value: "20+" },
];

export const skills = [
  {
    title: "Product Management",
    skills: [
      {
        name: "Jira",
        image: "https://www.svgrepo.com/show/452234/jira.svg",
      },
      {
        name: "Notion",
        image: "https://www.svgrepo.com/show/452466/notion.svg",
      },
      {
        name: "Confluence",
        image: "https://www.svgrepo.com/show/452236/confluence.svg",
      },
      {
        name: "Figma",
        image: "https://www.svgrepo.com/show/452202/figma.svg",
      },
      {
        name: "Miro",
        image: "https://www.svgrepo.com/show/354049/miro.svg",
      },
      {
        name: "Asana",
        image: "https://www.svgrepo.com/show/353420/asana.svg",
      },
      {
        name: "Productboard",
        image: "https://www.svgrepo.com/show/306350/productboard.svg",
      },
    ],
  },
  {
    title: "Analytics & Data",
    skills: [
      {
        name: "Google Analytics",
        image:
          "https://www.svgrepo.com/show/353806/google-analytics.svg",
      },
      {
        name: "Mixpanel",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQtPLTjCjHqF84U5CsQzNMvMOE2jOZT12_X4Q&s",
      },
      {
        name: "SQL",
        image:
          "https://www.svgrepo.com/show/331760/sql-database-generic.svg",
      },
      {
        name: "Excel",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Microsoft_Office_Excel_%282019%E2%80%93present%29.svg/2203px-Microsoft_Office_Excel_%282019%E2%80%93present%29.svg.png",
      },
      {
        name: "Google Console",
        image:
          "https://www.svgrepo.com/show/353808/google-cloud.svg",
      },
    ],
  },
  {
    title: "Agile & Frameworks",
    skills: [
      {
        name: "Scrum",
        image:
          "https://www.svgrepo.com/show/374187/vscode-runner.svg",
      },
      {
        name: "Kanban",
        image:
          "https://www.svgrepo.com/show/532634/circle-dashed.svg",
      },
      {
        name: "RICE/MoSCoW",
        image:
          "https://www.svgrepo.com/show/306497/phabricator.svg",
      },
      {
        name: "User Research",
        image:
          "https://www.svgrepo.com/show/488884/user.svg",
      },
      {
        name: "A/B Testing",
        image:
          "https://www.svgrepo.com/show/504814/ab-testing.svg",
      },
    ],
  },
  {
    title: "Technical Basics",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Git",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Git_icon.svg/2048px-Git_icon.svg.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://www.muftlo.com/favicon.ico",
    role: "Associate Product Manager",
    company: "Muftlo",
    date: "April 2025 – Present",
    desc: "Led 0→1→N development of a B2B real estate property discovery platform, launching 25+ features across web and mobile. Defined product strategy through user research (20+ interviews) and market analysis, improving user satisfaction by 35%. Authored PRDs, user stories, and acceptance criteria, aligning cross-functional teams on a clear product vision. Leveraged data (Google Analytics, SQL) to track key metrics and increase feature adoption by 25%. Owned Agile execution and go-to-market strategy, driving 40% growth in user acquisition.",
    skills: [
      "Product Strategy",
      "PRD Documentation",
      "User Research",
      "Agile/Scrum",
      "Google Analytics",
      "SQL",
      "Figma",
      "Stakeholder Management",
      "Go-to-Market",
    ],
    doc: "https://drive.google.com/file/d/17qA1fyFMIswBeHKFOzkalnVRcvv92k7F/view?usp=sharing",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLChBIOUdoAJdB9qEo5XXWAAw7IcKaFwOFbXOMic0k9A&s",
    role: "Product Management Apprentice",
    company: "Celebal Technologies",
    date: "Jan 2025 – Apr 2025",
    desc: "Supported end-to-end product lifecycle by translating business needs into actionable features. Worked closely with design and engineering teams to deliver user-centric solutions. Assisted in backlog management, sprint planning, and feature prioritization. Leveraged user feedback and data insights to improve product usability and performance.",
    skills: [
      "Product Lifecycle",
      "Backlog Management",
      "Sprint Planning",
      "Feature Prioritization",
      "User Feedback",
      "Cross-functional Collaboration",
    ],
    doc: "https://drive.google.com/file/d/13l8Rl8F75mSgT0AhOEAW-MSlDGmg0in6/view?usp=sharing",
  },
];

export const education = [
  {
    id: 0,
    img: "https://miro.medium.com/v2/resize:fit:2400/1*RI9FtaD0JZq4bW3HMbnzWg.jpeg",
    school: "Arya College of Engineering & I.T, Jaipur (RTU)",
    date: "July 2021 – May 2025",
    grade: "8.3 GPA",
    desc: "Completed a Bachelor's degree in Computer Science and Engineering at Arya College of Engineering & I.T, Jaipur. Studied Data Structures, Algorithms, DBMS, Operating Systems, Computer Networks, and Web Technologies. Actively participated in product and tech communities.",
    degree: "Bachelor of Technology – Computer Science",
  },
];

export const certifications = [
  "Product Management",
  "Scrum / Agile",
  "MySQL",
  "MongoDB",
  "MERN Stack",
  "SDLC",
];

export const projects = [
  {
    id: 0,
    title: "Search Abode : Real Estate Listing Platform",
    date: "Feb 2026 – Present",
    description:
      "Led product strategy for a B2B Real Estate Property Discovery Platform. Delivered 25+ features across web & mobile, wrote 20+ PRDs, conducted 20+ user interviews, and drove 40% growth in user acquisition through Agile execution and data-driven roadmapping.",
    impact: "40% user acquisition growth · 35% user satisfaction improvement",
    image:
      "https://raw.githubusercontent.com/Rakeshere/01portfolio/main/public/Search.png",
    tags: [
      "Product Strategy",
      "PRD",
      "User Research",
      "Agile",
      "Google Analytics",
      "Figma",
    ],
    category: "product management",
    github: "(Confidential)",
    webapp: "https://www.shutterstock.com/image-photo/coming-soon-message-written-on-600nw-2560537353.jpg",
  },
  {
    id: 1,
    title: "Kirtilals Jewellery : Ecommerce Platform",
    date: "Jun 2025 – Aug 2025",
    description:
      "A usercentric eCommerce platform enabling customers to explore and purchase jewellery based on category, price, and occasion, with intuitive browsing, product comparison, and a smooth checkout experience.",
    impact: "Owned product lifecycle, building intuitive user experiences.",
    image:
      "https://raw.githubusercontent.com/Rakeshere/01portfolio/main/public/kirtilals.png",
    tags: ["React Js", "Node Js", "Redux", "Bootstrap", "MongoDB"],
    category: "web app",
    github: "(Not Available)",
    webapp: "https://www.kirtilals.com/",
  },
  {
    id: 2,
    title: "Oranza : Canada Based Clothing Brand",
    date: "Jan 2026 – Feb 2026",
    description:
      "An eCommerce platform for a Canada-based clothing brand, enabling seamless product discovery and online purchasing with a smooth user experience.",
    impact: "Seamless product discovery & checkout, improving shopping experience.",
    image:
      "https://raw.githubusercontent.com/Rakeshere/01portfolio/main/public/oranza.png",
    tags: ["React Js", "MongoDB", "Express Js", "Tailwind", "Node JS"],
    category: "web app",
    github: "(Not Available)",
    webapp: "https://orenza.vercel.app/",
  },
  {
    id: 3,
    title: "Relaint Hosuing : Real Estate",
    date: "Jan 2026 – Feb 2026",
    description:
      "A modern, fully responsive real estate web platform enabling users to explore properties with intuitive search, filters, and seamless navigation. Demonstrates strong UI/UX design and frontend development fundamentals.",
    impact: "Optimized user experience helping attract and engage new audiences.",
    image:
      "https://raw.githubusercontent.com/Rakeshere/01portfolio/main/public/reliant.png",
    tags: ["React", "Nodejs", "JavaScript", "Tailwind"],
    category: "web app",
    github: "(Not Available)",
    webapp: "https://www.relianthousing.in/",
  },
  {
    id: 4,
    title: "CineHut : Film Studio",
    date: "Feb 2026 – Mar 2026",
    description:
      "A modern, fully responsive film studio platform enabling users to explore movies and shows with intuitive navigation, smart filtering, and a seamless experience.",
    impact: "Enhanced user experience by improving content visuablity and attracting a wider audience.",
    image:
      "https://raw.githubusercontent.com/Rakeshere/01portfolio/main/public/cinehut.png",
    tags: ["React", "Nodejs", "JavaScript", "Tailwind"],
    category: "web app",
    github: "(Not Available)",
    webapp: "https://cinehutfilmproduction.com/",
  },
];

export const TimeLineData = [
  { year: 2021, text: "Started B.Tech in Computer Science" },
  { year: 2023, text: "Built first full-stack product (Fiesta)" },
  { year: 2024, text: "Explored Product Management & Agile methodologies" },
  { year: 2025, text: "Joined Celebal Technologies as PM Apprentice" },
  { year: 2025, text: "Promoted to Associate Product Manager at Muftlo" },
];

export const analyticsData = [
  { name: "Jan", users: 200, success: 60 },
  { name: "Feb", users: 400, success: 75 },
  { name: "Mar", users: 600, success: 80 },
  { name: "Apr", users: 900, success: 85 },
  { name: "May", users: 1100, success: 88 },
  { name: "Jun", users: 1400, success: 90 },
  { name: "Jul", users: 1800, success: 92 },
  { name: "Aug", users: 2200, success: 95 },
];

export const pmLifecycle = [
  {
    id: 1,
    title: "Discovery & Research",
    desc: "Conducting user interviews, competitive analysis, and market research to identify pain points and opportunities.",
    stats: "20+ user interviews at Muftlo",
  },
  {
    id: 2,
    title: "PRD & Roadmapping",
    desc: "Writing detailed Product Requirement Documents, acceptance criteria, and aligning stakeholders on product vision.",
    stats: "20+ PRDs written end-to-end",
  },
  {
    id: 3,
    title: "Prioritization (RICE/MoSCoW)",
    desc: "Using data-driven frameworks to rank features by impact, confidence, and effort to maximize value shipped.",
    stats: "25+ features shipped on-time",
  },
  {
    id: 4,
    title: "Agile Execution",
    desc: "Running sprint planning, backlog grooming, daily standups, and retrospectives to keep delivery velocity high.",
    stats: "40% growth in user acquisition",
  },
  {
    id: 5,
    title: "Metrics & Iteration",
    desc: "Tracking KPIs via Google Analytics and SQL, measuring feature adoption, and iterating based on data signals.",
    stats: "25% increase in feature adoption",
  },
];

export const prdLibrary = [
  {
    id: 0,
    type: "PRD",
    title: "Property Discovery Platform",
    desc: "End-to-end PRD for Muftlo's B2B real estate search and discovery platform covering search filters, listing management, and lead capture flows.",
    link: "https://drive.google.com/file/d/1XZbsdY8DoOCUY38WXgcrNZPgPB9qLivL/view?usp=drive_link",
  },
  {
    id: 1,
    type: "PRD",
    title: "User Onboarding Flow",
    desc: "PRD for redesigning the user onboarding experience, reducing drop-off by 35% through progressive disclosure and contextual tooltips.",
    link: "https://drive.google.com/file/d/1XZbsdY8DoOCUY38WXgcrNZPgPB9qLivL/view?usp=drive_link",
  },
  {
    id: 2,
    type: "Analysis",
    title: "Competitive Market Analysis",
    desc: "Deep-dive competitive analysis of B2B real estate SaaS platforms covering pricing, feature gaps, and positioning opportunities.",
    link: "https://drive.google.com/file/d/1XZbsdY8DoOCUY38WXgcrNZPgPB9qLivL/view?usp=drive_link",
  },
  {
    id: 3,
    type: "SRS",
    title: "Sprint Planning & Retrospectives",
    desc: "Documented Agile ceremonies including sprint goals, velocity tracking, and team retrospective action items across 8 sprints.",
    link: "https://drive.google.com/file/d/1XZbsdY8DoOCUY38WXgcrNZPgPB9qLivL/view?usp=drive_link",
  },
];